// extracted by mini-css-extract-plugin
export default {"event-details-wrapper":"events_event-details-wrapper__q07tL"};